import { z } from "zod";

export const onboardingBrandFormSchema = z.object({
  name: z.string().min(1).max(255),
  mission: z.string().min(1).max(500),
  homepage: z.string().url(),
});
